// @flow

import * as React from 'react';
import styles from './MenuList.less';

type Props = {|
  /** Whether this list uses a fixed width */
  fixedWidth?: boolean,

  /** List contents of your choosing. Should be <li> elements */
  children?: React.Node,

  /** Minimum height of the menu list */
  minHeight?: string,

  /** Function to set the ref to the menu list */
  setRef?: any => React.ElementRef<*>,
|};

const MenuList = (props: Props) => (
  <ul
    ref={el => {
      if (props.setRef) {
        props.setRef(el);
      }
    }}
    style={{ minHeight: props.minHeight }}
    className={`${styles.menuList} ${props.fixedWidth ? styles.fixedWidth : ''}`}
  >
    {props.children}
  </ul>
);

MenuList.defaultProps = {
  fixedWidth: false,
  children: undefined,
};

export default MenuList;
